import { validateTIN, notifyRCMTin } from './requests';

export const validateTINSaga = async ({ action }) => {
  return validateTIN(action.payload);
};

export const notifyRCMTinSaga = async ({ action }) => {
  return notifyRCMTin(action.payload);
};
